import { defineComponent as v, computed as w, useAttrs as y, openBlock as C, createBlock as $, unref as r, normalizeStyle as b, normalizeClass as k, withCtx as i, createVNode as d, Transition as N, withDirectives as O, mergeProps as B, withKeys as S, renderSlot as m, vShow as K, normalizeProps as M, guardReactiveProps as P } from "vue";
import "@popperjs/core";
import { RevList as R } from "@ds/components/List";
import { RevPopover as x } from "@ds/components/Popover";
import { omit as z } from "../../utils/omit.js";
import { tw as n } from "../../utils/tailwind.js";
const T = /* @__PURE__ */ v({
  name: "RevContextualMenu",
  inheritAttrs: !1,
  __name: "ContextualMenu",
  props: {
    disabled: { type: Boolean, default: !1 },
    listClassNames: { default: "" },
    contentClassNames: { default: "" },
    modifiers: { default: void 0 },
    position: { default: "auto" },
    role: { default: "menu" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 }
  },
  emits: ["close", "keydown", "open"],
  setup(e) {
    const u = e, f = {
      role: "menuitem"
    }, c = w(() => z(y(), ["class", "style"]));
    function g(t, s) {
      t && s();
    }
    const p = (t) => {
      const s = t.split("-", 1)[0], o = {
        bottom: n`origin-top`,
        left: n`origin-right`,
        right: n`origin-left`,
        top: n`origin-bottom`
      }[s];
      return [
        n`bg-overlap-default-low shadow-long rounded-sm inline-block min-w-240 max-w-320 overflow-y-auto`,
        o,
        u.listClassNames
      ];
    };
    return (t, s) => (C(), $(r(x), {
      class: k(t.$attrs.class),
      "content-class-names": e.contentClassNames,
      modifiers: e.modifiers,
      position: e.position,
      "should-hide-on-click-outside": e.shouldHideOnClickOutside,
      "should-show-on-mount": e.shouldShowOnMount,
      style: b(t.$attrs.style),
      "trigger-element-id": e.triggerElementId,
      onClose: s[0] || (s[0] = (o) => t.$emit("close")),
      onOpen: s[1] || (s[1] = (o) => t.$emit("open"))
    }, {
      trigger: i((o) => [
        m(t.$slots, "trigger", M(P({ ...o, isOpen: o.isOpen && !e.disabled })))
      ]),
      content: i(({ hide: o, isOpen: l, position: h }) => [
        d(N, {
          appear: "",
          "enter-active-class": "motion-safe:duration-300 motion-safe:ease-out",
          "enter-from-class": "scale-0 opacity-0",
          "leave-active-class": "motion-safe:duration-300 motion-safe:ease-in",
          "leave-to-class": "scale-0 opacity-0"
        }, {
          default: i(() => [
            O(d(r(R), B({
              "aria-expanded": l && !e.disabled,
              class: p(h),
              "has-external-borders": !1,
              role: e.role
            }, c.value, {
              onKeydown: [
                (a) => t.$emit("keydown", a, o),
                S((a) => g(l, o), ["esc"])
              ]
            }), {
              default: i(() => [
                m(t.$slots, "items", {
                  attrs: f,
                  hide: o
                })
              ]),
              _: 2
            }, 1040, ["aria-expanded", "class", "role", "onKeydown"]), [
              [K, l && !e.disabled]
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["class", "content-class-names", "modifiers", "position", "should-hide-on-click-outside", "should-show-on-mount", "style", "trigger-element-id"]));
  }
});
export {
  T as default
};
